import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import type { CoachSessionPrepEmergingPatternItem } from "@/lib/behavior/viewModels/buildCoachSessionPrepEmergingPatterns";

interface PatternDetailSheetProps {
  pattern: CoachSessionPrepEmergingPatternItem | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenEvidenceReference: (reference: {
    label: string;
    link: string | null;
    evidenceId?: string | null;
    viewed?: boolean;
  }) => void;
}

export function PatternDetailSheet({
  pattern,
  open,
  onOpenChange,
  onOpenEvidenceReference,
}: PatternDetailSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-md">
        {pattern ? (
          <div className="space-y-6">
            <SheetHeader>
              <SheetTitle>{pattern.title}</SheetTitle>
              <SheetDescription>{pattern.stateLabel} pattern</SheetDescription>
            </SheetHeader>

            <section className="space-y-3 rounded-xl border border-border/60 bg-muted/20 p-4">
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">What stands out</p>
              <p className="text-sm text-foreground">{pattern.summary}</p>
              <p className="text-sm text-muted-foreground">{pattern.whyItMatters}</p>
            </section>

            <section className="space-y-4 rounded-xl border border-border/60 p-4">
              <div className="space-y-2">
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">What to probe next</p>
                <p className="text-sm text-muted-foreground">{pattern.whatToProbe}</p>
              </div>

              <div className="space-y-2">
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Evidence</p>
                {pattern.evidence.length > 0 ? (
                  pattern.evidence.map((entry) => (
                    <div key={`${pattern.id}-${entry.label}`} className="border-t border-border/50 pt-3 first:border-t-0 first:pt-0">
                      {entry.link ? (
                        <Button
                          type="button"
                          variant="link"
                          className="h-auto p-0 text-sm"
                          onClick={() => onOpenEvidenceReference(entry)}
                        >
                          {entry.label}
                        </Button>
                      ) : (
                        <p className="text-sm text-foreground">{entry.label}</p>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-sm text-muted-foreground">
                    Keep gathering evidence here. Coach Veera does not have enough repeated material yet.
                  </p>
                )}
              </div>
            </section>
          </div>
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
